import {
  createVisitorHandler,
  visitorCookieNames,
} from "@bindery/shared/visitor";
import { log } from "./consumer";

export {
  clickMaxAge,
  decodeClickCookie,
  encodeClickCookie,
  parseVisitorPayload,
  serializeVisitorCookie,
  VISITOR_ENDPOINT,
  VISITOR_MAX_AGE_SECONDS,
} from "@bindery/shared/visitor";

const COOKIE_PREFIX = "retells";

export const { visitor: VISITOR_COOKIE, click: CLICK_COOKIE } =
  visitorCookieNames(COOKIE_PREFIX);

export const handleVisitor = createVisitorHandler({
  cookiePrefix: COOKIE_PREFIX,
  log,
});
